export default __webpack_public_path__ + "9eda72c2b98a3556f3d95db9e4a2ec1d.svg";